import { Component, Input, OnInit } from "@angular/core";
import { DataService_Student_DigitalID } from "../../shared/data.service";
import { DigitalIDImportPreviewRequest } from "../../shared/DigitalIDImportPreviewRequest";
import { ImportPreviewRequest } from "../../shared/ImportPreviewRequest";

@Component({
	selector: "caass-digital-id-batch-import-table",
	templateUrl: "./digital-id-batch-import-table.component.html",
	styleUrls: ["./digital-id-batch-import-table.component.css"],
})
export class DigitalIdBatchImportTableComponent implements OnInit {
	constructor(private idService: DataService_Student_DigitalID) {}

	ngOnInit(): void {
		this.loadPerson();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() Processing: boolean = false;
	FormatOption: any;
	ImportFileData: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	lstPerson: any = [];

	lstSchoolName: any = [];
	lstStudentActiveDesc: any = [];
	lstValidEntryDesc: any = [];
	lstProgressDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	loadPerson() {
		if (this.FormatOption == undefined || this.ImportFileData == undefined) {
			return;
		}

		this.loading = true;

		let parms: ImportPreviewRequest = {
			FormatOption: this.FormatOption.ID,
			Base64File: this.ImportFileData,
		};

		var result = this.idService.LoadImportPreviewData(parms);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				for (var z = 0; z < this.lstPerson.length; z++) {
					var next = this.lstPerson[z];

					next.UID = Number(z + 1);
				}

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolName))).sort();
				this.lstStudentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StudentActiveDesc))).sort();
				this.lstValidEntryDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ValidEntryDesc))).sort();
				this.lstProgressDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ProgressDesc))).sort();

				this.loading = false;

				// this.LoadNext(0);
				this.LoadAll();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	LoadAll() {
		//
		// Create Request
		//
		let lstStudentIDs: string[] = Array.from(new Set(this.lstPerson.map((item: any) => String(item.StudentID))));
		lstStudentIDs = lstStudentIDs.sort();

		let parms: DigitalIDImportPreviewRequest = {
			lstStudentIDs: lstStudentIDs,
		};

		var result = this.idService.LoadImportPreviewAll(parms);
		result.subscribe(
			(response) => {
				var data: any = response;

				//
				// Create dictionary (js Map) of student data so the data can be looked up later
				// (There might be repeated Student IDs)
				//
				let StudentData: Map<string, any> = new Map();

				for (var z = 0; z < data.length; z++) {
					var next = data[z];

					StudentData.set(next.StudentID, next);
				}

				//
				// Go through person list
				// Update with data from dictionary
				//

				for (var z = 0; z < this.lstPerson.length; z++) {
					var nextPerson = this.lstPerson[z];
					var nextData = StudentData.get(nextPerson.StudentID); //Search for data in dictionary

					nextPerson.PersonID = nextData.PersonID;
					nextPerson.StudentName = nextData.StudentName;
					nextPerson.SchoolName = nextData.SchoolName;
					nextPerson.StudentActive = nextData.StudentActive;
					nextPerson.StudentActiveDesc = nextData.StudentActiveDesc;
					nextPerson.ProgressInt = nextData.ProgressInt;
					nextPerson.ProgressDesc = nextData.ProgressDesc;
					nextPerson.ValidEntry = nextData.ValidEntry == true ? 1 : 0;
					nextPerson.ValidEntryDesc = nextData.ValidEntryDesc;
					nextPerson.ProgressInt = nextData.ProgressInt;
					nextPerson.ProgressDesc = nextData.ProgressDesc;
				}

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolName))).sort();
				this.lstStudentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StudentActiveDesc))).sort();
				this.lstValidEntryDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ValidEntryDesc))).sort();
				this.lstProgressDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ProgressDesc))).sort();
			},
			(error) => {}
		);
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	ClearData() {
		this.lstPerson = [];
		this.SelectedPerson = null;
	}

	onRemove(Person) {
		this.lstPerson = this.lstPerson.filter((p) => p.UID != Person.UID); //UID added to each row so you don't delete multiple
		this.onRowUnselect(null);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////

	GetColorDesc(ProgressInt) {
		if (ProgressInt == 0) {
			return "orangered";
		} else if (ProgressInt == 1) {
			return "orange";
		} else if (ProgressInt == 2) {
			return "green";
		}
	}
}
